export enum ElementStatus {
  Primary = 'primary',
  Success = 'success',
  Danger = 'danger',
  Warning = 'warning',
  Informative = 'informative',
}
